export class Tax {
    startDate: Date;
    endDate: Date;
    rate: number;
    amount : number;

}